
/* injects from baggage-loader */

'use strict';

import PasswordResetComponent from './passwordreset.component';

const PasswordResetPageModule = angular.module('password-reset-module', [
    'ui.router'
  ])
  .config(($stateProvider, $urlRouterProvider) => {
    'ngInject';

    $urlRouterProvider.otherwise('/');

    $stateProvider
      .state('passwordReset', {
        url: '/account/password-reset?token?username',
        title: 'Password Reset',
        component: 'passwordReset',
        // Resolve promises into controller bindings, see component for bindings
        // resolve: { }
      });
  })
  .run(function ($transitions, $location, $rootScope, User) {

    // Handle entrance to login page when user is already logged in
    $transitions.onEnter({ to: 'passwordReset' }, transition => {

      if (User.isUserLoggedIn() === true) {
        $location.path('/account/home');
        return transition.router.stateService.target('account.home');
      }

    });

    $transitions.onSuccess({ to: 'passwordReset' }, transition => {

      // Hide the header
      $rootScope.appState.hideHeader = true;

      // Hide the footer
      $rootScope.appState.hideFooter = true;

    });

  })
  .component('passwordReset', new PasswordResetComponent());

export default PasswordResetPageModule;
